import { writable } from "svelte/store";

const initialState = {};

const { subscribe, update } = writable(initialState);

const updateState = (obj) => {
  update((oldState) => ({ ...oldState, ...obj }));
};

export default {
  subscribe,
  updateState,
};
